module.exports = __webpack_public_path__ + "static/media/Screenshot3.a933265e.png";